module.exports = __webpack_public_path__ + "media/images/blog-dec-fbafd0336515c809599d9fa6c62bc27b.png";